// 妖精动漫网 - 声优表数据
export interface Seiyuu {
  id: string;
  name: string;
  gender: '女' | '男';
  debut: string;
  agency: string;
  specialty: string;
  introduction: string;
  representative: { role: string; work: string }[];
  image: string;
}

export const seiyuuList: Seiyuu[] = [
  {
    id: 'moriyama',
    name: '森山杏里',
    gender: '女',
    debut: '2016',
    agency: '青音事务所',
    specialty: '飒爽少女 / 元气女角',
    introduction: '以《风之精灵使》琳娅·夜莺一角走红的实力派声优，声线清亮富有张力，擅长塑造飒爽果敢的少女形象，代表作涵盖多部奇幻冒险作品。',
    representative: [
      { role: '琳娅·夜莺', work: '风之精灵使' },
      { role: '辉夜·月白', work: '幻夜物语' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20friendly%20young%20japanese%20female%20voice%20actress%20with%20shoulder%20length%20black%20hair%20and%20a%20warm%20smile%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-moriyama&orientation=squarish',
  },
  {
    id: 'shiraishi',
    name: '白石结衣',
    gender: '女',
    debut: '2015',
    agency: '橙风声优工作室',
    specialty: '温柔治愈 / 女王气场',
    introduction: '声线温润又不失气场，既能演绎治愈系少女，也能驾驭「花冠女王」般的威严角色，是治愈与优雅兼备的国民级女声优。',
    representative: [
      { role: '芙洛拉·蔷薇', work: '花冠物语' },
      { role: '雪绪', work: '星野之森' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20graceful%20japanese%20female%20voice%20actress%20with%20long%20straight%20hair%20and%20a%20serene%20expression%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-shiraishi&orientation=squarish',
  },
  {
    id: 'kamiya',
    name: '神谷凉子',
    gender: '女',
    debut: '2014',
    agency: '明月声优企划',
    specialty: '清冷知性 / 神秘系',
    introduction: '以清冷空灵的声线著称，擅长演绎神秘、知性的角色，为星之精灵艾露赋予超越语言的分量感，广受奇幻题材观众的喜爱。',
    representative: [
      { role: '艾露·星语', work: '星野之森' },
      { role: '司星者·零', work: '深渊回响' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20cool%20mysterious%20japanese%20female%20voice%20actress%20with%20dark%20hair%20and%20calm%20eyes%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-kamiya&orientation=squarish',
  },
  {
    id: 'kurosaki',
    name: '黑崎真奈',
    gender: '女',
    debut: '2017',
    agency: '青音事务所',
    specialty: '低沉酷飒 / 动作系',
    introduction: '低沉克制又充满爆发力的声线，完美诠释暗系刺客的凌厉与隐忍，诺拉·幽兰的「月光瞬影」名场面由其倾情演绎。',
    representative: [
      { role: '诺拉·幽兰', work: '月光回廊' },
      { role: '绯月', work: '夜幕行者' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20sharp%20japanese%20female%20voice%20actress%20with%20bob%20haircut%20and%20a%20slightly%20serious%20look%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-kurosaki&orientation=squarish',
  },
  {
    id: 'fujiwara',
    name: '藤原千夏',
    gender: '女',
    debut: '2018',
    agency: '雨音声优学院',
    specialty: '清亮少年音 / 治愈系',
    introduction: '声线清亮而温柔，被誉为「治愈天花板」之一，为水之咏者汐音·泉带来抚慰人心的力量，深受治愈系观众喜爱。',
    representative: [
      { role: '汐音·泉', work: '深渊水镜' },
      { role: '雪之丘·千夏', work: '恋语花束' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20gentle%20japanese%20female%20voice%20actress%20with%20soft%20wave%20hair%20and%20a%20bright%20smile%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-fujiwara&orientation=squarish',
  },
  {
    id: 'takahashi',
    name: '高桥美月',
    gender: '女',
    debut: '2016',
    agency: '橙风声优工作室',
    specialty: '元气少女 / 活力系',
    introduction: '充满生命力的元气声线，将森林守护者提亚·晨露的开朗展现得淋漓尽致，活跃于各类轻奇幻与校园题材。',
    representative: [
      { role: '提亚·晨露', work: '星野之森' },
      { role: '小阳', work: '放学后的妖精' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20lively%20young%20japanese%20female%20voice%20actress%20with%20twin%20tails%20and%20an%20energetic%20smile%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-takahashi&orientation=squarish',
  },
  {
    id: 'sato',
    name: '佐藤健一',
    gender: '男',
    debut: '2013',
    agency: '岚山声优事务所',
    specialty: '热血少年 / 沉稳兄长',
    introduction: '声线清爽而富有爆发力，擅长热血少年与可靠兄长两类角色，为翼兽行者洛林·羽注入满满的成长弧光。',
    representative: [
      { role: '洛林·羽', work: '风之精灵使' },
      { role: '月见·响', work: '青空之魂' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20friendly%20young%20japanese%20male%20voice%20actor%20with%20neat%20black%20hair%20and%20a%20warm%20smile%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-sato&orientation=squarish',
  },
  {
    id: 'tanaka',
    name: '田中莉奈',
    gender: '女',
    debut: '2015',
    agency: '雨音声优学院',
    specialty: '温厚成熟 / 大姐姐系',
    introduction: '温厚中带着力量的大姐姐声线，将麦田守望者玛尔·金穗的烟火气与神圣感拿捏得恰到好处，广受喜爱。',
    representative: [
      { role: '玛尔·金穗', work: '幻夜妖精' },
      { role: '穗乃花', work: '四季穗语' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20mature%20japanese%20female%20voice%20actress%20with%20warm%20brown%20hair%20and%20a%20kind%20smile%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-tanaka&orientation=squarish',
  },
  {
    id: 'saotome',
    name: '早乙女瑠璃',
    gender: '女',
    debut: '2014',
    agency: '明月声优企划',
    specialty: '清冷空灵 / 悲情系',
    introduction: '以空灵而哀婉的声线著称，为月之祭司尤娜·月蚀带来极致的悲情感染力，「月蚀之夜」独白堪称教科书级表演。',
    representative: [
      { role: '尤娜·月蚀', work: '月光回廊' },
      { role: '琉璃', work: '薄暮之约' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20an%20elegant%20japanese%20female%20voice%20actress%20with%20long%20dark%20hair%20and%20a%20melancholic%20expression%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-saotome&orientation=squarish',
  },
  {
    id: 'okamoto',
    name: '冈本由纪',
    gender: '男',
    debut: '2016',
    agency: '岚山声优事务所',
    specialty: '清亮少年音 / 灵动系',
    introduction: '以清亮灵动的少年音演绎冬日花使雪莉·铃兰，将角色俏皮与清澈的特质诠释得恰到好处，近年来人气稳步上升。',
    representative: [
      { role: '雪莉·铃兰', work: '花冠物语' },
      { role: '苍', work: '冬之回廊' },
    ],
    image: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20boyish%20young%20japanese%20male%20voice%20actor%20with%20short%20brown%20hair%20and%20a%20cheerful%20grin%2C%20studio%20lighting%2C%20soft%20neutral%20background&width=400&height=400&seq=seiyuu-okamoto&orientation=squarish',
  },
];